import { MonetaryUnit } from "../../../CoStar/Api/Analytics/CommonEntities/Enums/index.js";
/** CoStar.Api.ForeignExchangeApiAdapter.MonetaryUnit */
export { MonetaryUnit };
